import { QueryAggregator } from "@/api/utils/QueryAggregator"
import { JuniferService } from "@/services/JuniferService"
import { AccountService } from "@/services/AccountService"
import { IJuniferTicket } from "@/models/juniferTickets/juniferTicket.types"

export const getInvoluntaryPaygSwitchTicket = (accountNumber: string) => {
  const queries = new QueryAggregator()
  const coreIdQuery = AccountService.getCoreIdByAccountNumber(accountNumber)
  const juniferTicketsQuery = JuniferService.getTicketsForAccount(
    coreIdQuery.data,
  )

  queries.add(coreIdQuery)
  queries.add(juniferTicketsQuery)

  const latestInvoluntaryPaygSwitchTicket =
    getLatestInvoluntaryPaygSwitchTicket(juniferTicketsQuery.data ?? [])

  return queries.setData(latestInvoluntaryPaygSwitchTicket).getAggregate()
}

export const getLatestInvoluntaryPaygSwitchTicket = (
  juniferTickets: IJuniferTicket[],
) => {
  const involuntaryPaygSwitchTickets = juniferTickets.filter(
    (juniferTicket: IJuniferTicket) =>
      juniferTicket.isOpenInvoluntaryPaygTicket,
  )

  return [...involuntaryPaygSwitchTickets].sort((a, b) =>
    a.createdDate.isAfter(b.createdDate) ? -1 : 1,
  )[0]
}
